<template>
<div class="scrolling-text-container" ref="scrollingTextContainer">
    <div class="scrolling-text" :style="style" ref="scrollingText">
        {{ text }}
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            style: "" // Adjust the duration based on your preference
        };
    },
    props: {
        text: String
    },

    methods: {
        checkTextWidth() {

            this.$nextTick(() => {
                const containerWidth = this.$refs.scrollingTextContainer.offsetWidth;
                const textWidth = this.$refs.scrollingText.offsetWidth;

                if (textWidth > containerWidth) {
                    const duration = textWidth / 50;
                    this.style = `animation-duration:${duration}s`;
                }

            })

        },

    },
    mounted() {
        this.checkTextWidth()
    }
};
</script>

<style scoped>
.scrolling-text-container {
    overflow: hidden;
}

.scrolling-text {
    white-space: nowrap;
    font-size: 14px;

    width: fit-content;
    animation: scrollText linear infinite;
}

@keyframes scrollText {
    to {
        transform: translateX(-100%);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/scrollingText.vue